export default __webpack_public_path__ + "static/media/132042004_900134077396592_1361356072297457159_n.d6db6176.jpg";